export enum ContractOverviewPathsEnum {
  contractsOverview = '/contracts-overview',
}
